export default __webpack_public_path__ + "static/media/cart-violet.22915698.svg";